import { render } from "./UserMenu.vue?vue&type=template&id=6b5ca673"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script